const TRACK_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "gclid", "fbclid"];

export function trackEvent(name, params = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(name, params);
    }
  } catch (e) {
    /* analytics must never break the page */
  }
}

export function getTracking() {
  try {
    return JSON.parse(sessionStorage.getItem("acv_tracking") || "{}");
  } catch (e) {
    return {};
  }
}

export function initAnalytics() {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  TRACK_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) found[k] = v;
  });
  if (Object.keys(found).length) {
    sessionStorage.setItem("acv_tracking", JSON.stringify(found));
  }
  document.addEventListener("click", (e) => {
    const tel = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (tel) {
      trackEvent("phone_click", { location: tel.getAttribute("data-testid") || "link" });
      return;
    }
    const tracked = e.target.closest && e.target.closest("[data-track]");
    if (tracked) {
      trackEvent(tracked.getAttribute("data-track"), {
        label: (tracked.textContent || "").trim().slice(0, 60),
      });
    }
  });
}
